import React from 'react';
import classnames from 'classnames';
import FollowingWatchIcon from '../FollowingWatch';
import CircleWrap, { Props as CircleWrapProps } from '../../CircleWrap';
import s from './EyeDisc2.scss';

export type Props = Omit<CircleWrapProps, 'children'>;

const EyeDisc2: React.FC<Props> = ({ className, ...props }) => {
  return (
    <CircleWrap
      circleClassName={classnames(s['disc'], className)}
      size={props.size}
    >
      <FollowingWatchIcon {...props} disableDefaultColors />
    </CircleWrap>
  );
};
EyeDisc2.displayName = 'EyeDisc2';

export default EyeDisc2;
